
import { Vue, Component } from "vue-property-decorator";

function preventDefaults(e: any) {
    e.preventDefault()
    e.stopPropagation()
}

@Component({})

export default class DragNDropBase extends Vue {

    isHighlighted = false;

    mounted() {
        this.subscribe();
    }

    subscribe() {
        const dropArea = this.$el.getElementsByTagName?.("label")[0];

        if(dropArea) {
            // Prevent default drag behaviors
            const preventEventNames = ['dragenter', 'dragover', 'dragleave', 'drop'];
            preventEventNames.forEach((eventName: string) => {
                dropArea.addEventListener(eventName, preventDefaults, false)
                document.body.addEventListener(eventName, preventDefaults, false)
            });

            // Highlight drop area when item is dragged over it
            const highlightEventNames = ['dragenter', 'dragover']
            highlightEventNames.forEach((eventName: string) => {
                dropArea.addEventListener(eventName, this.highlight, false)
            });

            ['dragleave', 'drop'].forEach(eventName => {
                dropArea.addEventListener(eventName, this.unhighlight, false)
            });

            // Handle dropped files
            dropArea.addEventListener('drop', this.handleDrop as EventListenerOrEventListenerObject, false)
        }
    }

    highlight() {
        this.isHighlighted = true;
    }

    unhighlight() {
        this.isHighlighted = false;
    }

    handleDrop(event: DragEvent) {
        //
    }
}

